export enum MoneyColor {
  Income = "income",
  Expense = "expense"
}

export type Transaction = {
  id: string
  amount: number
  description: string
  paidAt: string
  intentId?: string
  fromPocketId?: string
  toPocketId?: string
}

export type TransactionRequest = {
  amount: number
  paidAt: string
  description: string
  intentId?: string
  fromPocketId?: string
  toPocketId?: string
}

export type Intent = {
  id: string
  amount: number
  description: string
  paymentDate: string
  finishDate?: string
  periodInMonths: number
  fromPocketId?: string
  toPocketId?: string
}

export type IntentRequest = {
  amount: number
  paymentDate: string
  finishDate?: string
  periodInMonths: number
  description: string
  fromPocketId?: string
  toPocketId?: string
}

export type Pocket = {
  id: string
  title: string
  balance: number
  isMainPocket: boolean
  goal?: PocketGoal
  tags: Array<string>
}

export type PocketGoal = {
  money: number
  dueDate?: string
}

export type PocketRequest = {
  title: string
}

export interface PocketDetails extends Pocket {
  transactions: Array<Transaction>
}

export type MonthDetails = {
  balance: number
  totalBalance: number
  everydayBaseBudget: number
  intents: Array<Intent>
  transactions: Array<Transaction>
  pockets: Array<Pocket>
  mainPocketId: string
}

export const ZeroMonthDetails = {
  balance: 0,
  totalBalance: 0,
  everydayBaseBudget: 0,
  intents: [],
  transactions: [],
  pockets: [],
  mainPocketId: '',
}

export type TodayDetails = {
  freeMoneyForToday: number
  everydayBaseBudget: number
  todayExpenses: Array<Transaction>
  pockets: Array<Pocket>
  mainPocketId: '',
}

export type LoginRequest = {
  email: string,
  password: string
}


export type LoginResponse = {
  accessToken: string
}
